export default "__VITE_ASSET__DxWR0Qyl__"